import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../mock';

export default function Testimonials() {
  return (
    <section id="voices" className="relative py-24 md:py-36 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-px bg-[#e4cfaf]" />
          <span className="uppercase text-[11px] tracking-[0.28em] text-[#e4cfaf]/90">Landlord Voices</span>
        </div>
        <h2 className="serif text-white text-4xl md:text-6xl leading-[1.05] max-w-3xl mb-16">
          What our <span className="italic-serif">landlords say</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div key={t.name} className="tilt-card border border-white/10 bg-[#141416] p-8 md:p-10 rounded-sm">
              <Quote className="w-8 h-8 text-[#e4cfaf]/70 mb-5" />
              <p className="serif text-white/90 text-xl md:text-2xl leading-relaxed mb-8">
                “{t.quote}”
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-white/10">
                <div className="w-12 h-12 rounded-full border border-[#e4cfaf]/40 flex items-center justify-center serif text-[#e4cfaf] text-sm tracking-wider">
                  {t.initials}
                </div>
                <div>
                  <div className="text-white text-[15px]">{t.name}</div>
                  <div className="text-white/50 text-sm">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
